export default __webpack_public_path__ + "static/media/1_2.606cf6fc.jpg";